export const DARK = 'DARK';
export const LITE = 'LITE';
